import { ProductCardStructure } from 'common/components';
import { INTERIOR_DOORS_CDN_PATH } from 'landings/interior-doors/interior-doors-constants';

export const INTERIOR_DOORS_OPENING_TYPES_LIST: ProductCardStructure[] = [
  {
    alt: 'Одностворчатые двери',
    name: 'Одностворчатые',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/1.jpg/1.jpg`,
  },
  {
    alt: 'Двустворчатые двери',
    name: 'Двустворчатые',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/2.jpg/2.jpg`,
  },
  {
    alt: 'Скрытые двери',
    name: 'Скрытые',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/3.jpg/3.jpg`,
  },
  {
    alt: 'Скрытые раздвижные двери',
    name: 'Скрытые раздвижные',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/4.jpg/4.jpg`,
  },
  {
    alt: 'Раздвижные двери',
    name: 'Раздвижные',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/5.jpg/5.jpg`,
  },
  {
    alt: 'Складные двери',
    name: 'Складные',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/opening-types/6.jpg/6.jpg`,
  },
];
